// @flow

"use strict";

import Raven from "raven-js";
import ravenOptions from "../../raven/raven-options";
import Environment from "./environment";
import PlacementSetting from "./placement-setting";


/**
 * ロガー
 * 本番ではエラーをSentryへ送信する
 */
export default class Logger {
  constructor(environment: Environment, sentryLogger: RavenStatic) {
    this.environment = environment;
    this.sentryLogger = sentryLogger;
  }

  static getInstance(environment: Environment, placementSetting: PlacementSetting, window: Window): Logger {
    let sentryLogger = null;
    try {
      if (placementSetting.sentryDSN) {
        sentryLogger = Raven.config(placementSetting.sentryDSN, ravenOptions).install();
      }
    } catch (e) {
      console.error(e);
    }

    const logger: Logger = new Logger(environment, sentryLogger);

    // Singleton
    Logger.getInstance = function(): Logger {
      return logger;
    };

    return logger;
  }

  info(message: string) {
    // 本番以外ではコンソールに表示
    if (!this.environment.isProduction()) {
      console.log(message);
    }
  }

  error(e: Error) {
    if (this.sentryLogger != null) {
      this.sentryLogger.captureException(e, {tags: {scope: 'uzou'}});  // タグ
    }
    // 本番以外ではコンソールに表示
    if (!this.environment.isProduction()) {
      console.error(e);
    }
  }
}


// WEBPACK FOOTER //
// ./src/js/model/common/logger.js